

const orderFormVisible = () => {

    const items = document.querySelectorAll(".i-product");

    items.forEach(item => {
        const buttons = item.querySelectorAll(".i-product__btn");
        buttons.forEach(button => {
            button.addEventListener("click", () => {
                const body = document.querySelector("body");
                const form = item.querySelector(".i-product__form")
                form.classList.add("--js-open");
                body.classList.add("--opened-modal");
            })
        });
    });
}


const orderFormHidden = () => {

    const items = document.querySelectorAll(".i-product");
    items.forEach(item => {
        const closes = item.querySelectorAll(".i-product__form");
        closes.forEach(close => {
            close.addEventListener("click", (e) => {
                const element = e.target as HTMLElement

                if (element.classList.contains("f-order__close") || element === close) {
                    const body = document.querySelector("body");
                    close.classList.remove("--js-open")
                    body.classList.remove("--opened-modal");
                }
            })
        });
    });
}

orderFormVisible();
orderFormHidden();
